/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreStandardSubtaskCreateDto } from '../../models/core-standard-subtask-create-dto';
import { CoreStandardTaskResponseDto } from '../../models/core-standard-task-response-dto';

export interface StandardTasksControllerAddSubtask$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the standard task.
 */
  id: string;
      body: CoreStandardSubtaskCreateDto
}

export function standardTasksControllerAddSubtask(http: HttpClient, rootUrl: string, params: StandardTasksControllerAddSubtask$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreStandardTaskResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, standardTasksControllerAddSubtask.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreStandardTaskResponseDto>;
    })
  );
}

standardTasksControllerAddSubtask.PATH = '/o2-core/standard-tasks/{tenant}/{id}/subtasks';
